export default [
  {
    path: '/cars',
    name: 'car-list',
    component: () => import('@/views/cars/Index.vue'),
    meta: {
      pageTitle: 'Parc Véhicules',
      breadcrumb: [
        {
          text: 'Parc Véhicules',
          active: true,
        },
      ],
      description: 'Gestion professionnelle du parc véhicules, suivi des statuts, conducteurs et conformité.',
      accessibility: {
        ariaLabel: 'Liste des véhicules',
        help: 'Consultez, filtrez et gérez l’ensemble des véhicules utilisés pour la logistique et la livraison.',
      },
    },
  },
  {
    path: '/cars/add',
    name: 'car-add',
    component: () => import('@/views/cars/Create.vue'),
    meta: {
      pageTitle: 'Ajouter un véhicule',
      breadcrumb: [
        {
          text: 'Parc Véhicules',
          to: { name: 'car-list' },
        },
        {
          text: 'Ajouter',
          active: true,
        },
      ],
      description: 'Ajoutez un nouveau véhicule au parc pour le suivi logistique, la conformité et l’affectation des conducteurs.',
      accessibility: {
        ariaLabel: 'Formulaire d’ajout de véhicule',
        help: 'Renseignez toutes les informations techniques et administratives requises pour l’intégration d’un véhicule.',
      },
    },
  },
  {
    path: '/cars/edit/:id',
    name: 'car-edit',
    component: () => import('@/views/cars/Edit.vue'),
    meta: {
      pageTitle: 'Modifier un véhicule',
      breadcrumb: [
        {
          text: 'Parc Véhicules',
          to: { name: 'car-list' },
        },
        {
          text: 'Modifier',
          active: true,
        },
      ],
      description: 'Mettez à jour les informations d’un véhicule pour garantir la conformité et l’exactitude du parc.',
      accessibility: {
        ariaLabel: 'Formulaire de modification de véhicule',
        help: 'Modifiez les données techniques, administratives ou d’affectation du véhicule.',
      },
    },
  },
  {
    path: '/cars/show/:id',
    name: 'car-show',
    component: () => import('@/views/cars/Show.vue'),
    meta: {
      pageTitle: 'Fiche véhicule',
      breadcrumb: [
        {
          text: 'Parc Véhicules',
          to: { name: 'car-list' },
        },
        {
          text: 'Fiche détaillée',
          active: true,
        },
      ],
      description: 'Consultez la fiche détaillée d’un véhicule : informations techniques, conformité, affectation et historique logistique.',
      accessibility: {
        ariaLabel: 'Fiche détaillée du véhicule',
        help: 'Accédez à toutes les informations, documents et historiques liés à ce véhicule.',
      },
    },
  },
]
